import { GET_WASH_HISTORY, GET_WASH_HISTORY_DETAILS } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const washHistorySlice = createCrudSlice({
  name: "wash history",
  urls: {
    getList: GET_WASH_HISTORY,
    getDetails: GET_WASH_HISTORY_DETAILS,
  },
  initialFilters: {
    userId: "",
    branchId: "",
    planId: "",
    
  },
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
    items: [],
  },
});

// Export actions
export const { setFilter, resetFilters } = washHistorySlice.actions;

// Export thunks
export const { getList: getWashHistory, getDetails: getWashHistoryDetails } =
  washHistorySlice.thunks;

// Export reducer
export default washHistorySlice.reducer;
